var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.$t('set-value'),"ok-title":_vm.$t('close'),"ok-only":""},on:{"hide":_vm.close}},[_c('setting-item',{attrs:{"setting-var":_vm.settingVar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }